export const assignLocation = (url) => {
    window.location.href = url;
};

export const replaceLocation = (url) => {
    window.location.replace(url);
};